import { gql } from '@apollo/client'

export const PMS_TYPE_NAMES_QUERY = gql`
  query PMSTypeNames {
    pmsTypeNames {
      EN
      FA
    }
  }
`
